import { render, staticRenderFns } from "./c-table.vue?vue&type=template&id=36225a34&"
import script from "./c-table.vue?vue&type=script&lang=js&"
export * from "./c-table.vue?vue&type=script&lang=js&"
import style0 from "./c-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports